import cls from "./GameLeaderboardCard.module.scss";

function getRankLabel(index) {
  if (index === 0) return "1st";
  if (index === 1) return "2nd";
  if (index === 2) return "3rd";
  return `${index + 1}th`;
}

export default function GameLeaderboardCard({ rows = [] }) {
  return (
    <section className={cls.card}>
      <div className={cls.glowPink} />
      <div className={cls.glowBlue} />

      <div className={cls.header}>
        <div>
          <p className={cls.eyebrow}>Top Players</p>
          <h3 className={cls.title}>Leaderboard</h3>
        </div>

        <div className={cls.badge}>
          {rows.length} {rows.length === 1 ? "Player" : "Players"}
        </div>
      </div>

      {!rows.length ? (
        <div className={cls.emptyState}>
          <div className={cls.emptyIcon}>🏆</div>
          <h4>No leaderboard yet</h4>
          <p>No leaderboard data yet.</p>
        </div>
      ) : (
        <div className={cls.list}>
          {rows.map((row, idx) => {
            const rank = idx + 1;
            const isTop3 = rank <= 3;

            return (
              <article
                key={row.playerId || idx}
                className={`${cls.rowCard} ${isTop3 ? cls.topPlayer : ""}`}
              >
                <div className={cls.left}>
                  <div
                    className={`${cls.rankBadge} ${
                      rank === 1
                        ? cls.rank1
                        : rank === 2
                          ? cls.rank2
                          : rank === 3
                            ? cls.rank3
                            : cls.rankNormal
                    }`}
                  >
                    #{rank}
                  </div>

                  <div className={cls.playerMeta}>
                    <div className={cls.nameLine}>
                      <h4 className={cls.playerName}>
                        {row.displayName || "Unknown Player"}
                      </h4>
                      <span className={cls.playerNo}>
                        Player #{row.playerNo ?? "--"}
                      </span>
                    </div>

                    <p className={cls.rankText}>{getRankLabel(idx)} Place</p>
                  </div>
                </div>

                <div className={cls.stats}>
                  <div className={cls.statPill}>
                    <span className={cls.statLabel}>W</span>
                    <strong>{row.wins ?? 0}</strong>
                  </div>
                  <div className={cls.statPill}>
                    <span className={cls.statLabel}>L</span>
                    <strong>{row.losses ?? 0}</strong>
                  </div>
                  <div className={cls.statPill}>
                    <span className={cls.statLabel}>Turns</span>
                    <strong>{row.turnsPlayed ?? 0}</strong>
                  </div>
                  <div className={cls.statPill}>
                    <span className={cls.statLabel}>Match</span>
                    <strong>{row.guessesMatched ?? 0}</strong>
                  </div>
                  <div className={`${cls.statPill} ${cls.coinPill}`}>
                    <span className={cls.statLabel}>Clothes</span>
                    <strong>{row.currentCoins ?? 0}</strong>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
}
